<template>
  <span class="loader" :data-content="text">{{ text }}</span>
</template>

<script setup>
  defineProps({
    text: {
      type: String,
      default: 'Converting to MP4...'
    }
  });
</script>

<style lang="scss" scoped>
  @import "../css/vars";
  .loader {
    font-size: 32px;
    font-weight: bold;
    display: inline-block;
    color: $river-side-color;
    letter-spacing: 2px;
    position: relative;
    white-space: nowrap;

    &::after {
      content: attr(data-content);
      position: absolute;
      left: 0;
      top: 0;
      color: $white;
      width: 100%;
      height: 100%;
      overflow: hidden;
      box-sizing: border-box;
      animation: {
        name: animloader;
        duration: 1.75s;
        timing-function: ease-in-out;
        iteration-count: infinite;
        direction: alternate;
      }
    }

    @keyframes animloader {
      0% {
        width: 0%;
      }

      100% {
        width: 100%;
      }
    }
  }
</style>
